import script from "./HighlightsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./HighlightsList.vue?vue&type=script&lang=ts&setup=true"

import "./HighlightsList.vue?vue&type=style&index=0&id=6b8fa72a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8fa72a"]])

export default __exports__